import _ from "lodash";

export const getHtml = ({ props, state, showCarrier, callback}) => {
	const {
		publicGetBulkDeliveryBatch,
		bulkDeliveryBatch,
		publicGetBulkDelivery,
		bulkDelivery,
	} = props;
	const { bulkDeliveryId, bulkDeliveryBatchId, securityHash } = state;

	if (bulkDeliveryId) {
		if (bulkDelivery) { return {}; }

		publicGetBulkDelivery({
			params : {
				bulkDeliveryId,
				showCarrier,
				securityHash
			},
			callback : (err, r) => {
				if (err) { return { errors : [err] }; }

				const bulkDelivery = _.get(r, ['collections', 'bulkDeliveryCollection', 0]);
				if (!bulkDelivery) { return {errors : ['Missing bulkDelivery.']}; }
				if (!r.emailHtml) { return { errors : ['Missing info section']}; }
				return callback({ emailHtml : r.emailHtml });
			}
		});

	} else {
		if (bulkDeliveryBatch) { return {}; }
		publicGetBulkDeliveryBatch({
			params : {
				bulkDeliveryBatchId,
				showCarrier,
				securityHash
			},
			callback : (err, r) => {
				if (err) { return { errors : [err] }; }

				const bulkDeliveryBatch = _.get(r, ['collections', 'bulkDeliveryBatchCollection', 0]);
				if (!bulkDeliveryBatch) { return {errors : ['Missing bulkDeliveryBatch.']}; }
				if (!r.emailHtml) { return { errors : ['Missing info section']}; }
				return callback({ emailHtml : r.emailHtml });
			}
		});
	}
};